import * as bsLib from '@taabl/common-lib/calculators/blackscholes';
import {
    Constants
} from "./Constants";

export const NORMSDIST = bsLib.normalDistribution;
export const calculatePresentValueOfStockExDividend = bsLib.calculatePresentValueOfStockExDividend;
export const calculateCumulativeVolatility = bsLib.calculateCumulativeVolatility;
export const calculateIntermediateExcercisePrice = bsLib.calculateIntermediateExcercisePrice;
export const calculateCallProportionStockPresentValue = bsLib.calculateCallProportionStockPresentValue;
export const calculateCallProportionExcercisePricePV = bsLib.calculateCallProportionExcercisePricePV;
export const calculateCallOptionValue = bsLib.calculateCallOptionValue;
export const convertAndPerformCalculation = bsLib.convertAndPerformCalculation;
export const calculateValues = bsLib.calculateValues;

export function getFormulae() {
    let intermediate = {};
    let callOptions = {};
    let putOptions = {};
    let outputs = {};

    intermediate.pved = `Stock Price / (1+Annual Rate of Quarterly Dividends/4)^(4 * term)`;
    intermediate.pvee = `Exercise Price * EXP(- Discount Rate Bond Equivalent Yield * Term )`;
    intermediate.cv = `Volatility * SQRT(Term)`;

    callOptions.pspv = `NORMSDIST(LN(Present Value of Stock Ex-dividend / Present Value of Exercise Price)/
        Cumulative Volatility + Cumulative Volatility/2)`;

    callOptions.pepp = `- NORMSDIST(LN(Present Value of Stock Ex-dividend / Present Value of Exercise Price)/
        Cumulative Volatility - Cumulative Volatility/2)`;

    callOptions.value = `Present Value of Stock Ex-dividend * Proportion of Stock Present Value +
            Present Value of Exercise Price * Proportion of Exercise Price PV`;

    putOptions = Object.assign(callOptions);

    outputs.ecofv = `abs(Call Option Value)`;
    outputs.epofv = `Estimated Call Option Falir Value
        + Present Value of Exercise Price
        - Stock Price`;
    outputs.value_discount = `Stock Price * 0.15`;
    outputs.value_85_call = `Estimated Call Option Fair Value * 0.85`;
    outputs.value_15_put = `Estimated Put Option Fair Value *  0.15`;
    outputs.total_value_per_share = ` Value of Discount
                                    + Value of 85% Call Option
                                    + Value of 15 Put Option`;

    return {
        intermediate,
        callOptions,
        putOptions,
        outputs,
    };
}
export function calculateTermsInDays(term) {
    return Math.round(term * Constants.DAYS_IN_YEAR);
}

export function calculateTerm(termInDays) {
    return termInDays / Constants.DAYS_IN_YEAR;
}